import { render } from "./BadgeScanner.vue?vue&type=template&id=8eea0560&ts=true"
import script from "./BadgeScanner.vue?vue&type=script&lang=ts"
export * from "./BadgeScanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__